import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaFutbol, FaExternalLinkAlt } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t, language } = useLanguage();
  const isAr = language === 'ar';
  const devLink = (
    <a href="https://inveep.com" target="_blank" rel="noopener noreferrer" style={styles.devLink} className="footer-dev-inveep-link">
      Inveep
      <FaExternalLinkAlt style={styles.devLinkIcon} aria-hidden="true" />
    </a>
  );
  const devText = isAr
    ? <>تم تطوير الموقع بواسطة {devLink} – شركة ناشئة تونسية في مجال الابتكار</>
    : <>Développé par {devLink} – Startup tunisienne en innovation</>;
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div className="footer-grid" style={styles.grid}>
          <div className="footer-section" style={styles.section}>
            <div style={styles.logoSection}>
              <img 
                src="/images/logo.png" 
                alt="الرابطة الوطنية" 
                style={styles.footerLogo}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <FaFutbol style={{...styles.footerLogoIcon, display: 'none'}} />
            </div>
            <h3 style={styles.footerTitle}>الرابطة الوطنية</h3>
            <p style={styles.description}>
              الرابطة الوطنية لكرة القدم للهواة - المستوى الثاني
            </p>
            <p style={styles.description}>
              Ligue Amateur Niveau 2
            </p>
          </div>

          <div className="footer-section" style={styles.section}>
            <h4 style={styles.sectionTitle}>روابط سريعة</h4>
            <ul style={styles.linkList}>
              <li><Link to="/" style={styles.link}>الرئيسية</Link></li>
              <li><Link to="/matches" style={styles.link}>المباريات</Link></li>
              <li><Link to="/standings" style={styles.link}>الترتيب</Link></li>
              <li><Link to="/teams" style={styles.link}>الفرق</Link></li>
            </ul>
          </div>

          <div className="footer-section" style={styles.section}>
            <h4 style={styles.sectionTitle}>المزيد</h4>
            <ul style={styles.linkList}>
              <li><Link to="/communiques" style={styles.link}>{t('communiques')}</Link></li>
              <li><Link to="/useful-links" style={styles.link}>{t('usefulLinks')}</Link></li>
              <li><Link to="/committees" style={styles.link}>اللجان</Link></li>
              <li><Link to="/designations" style={styles.link}>التعيينات</Link></li>
            </ul>
          </div>

          <div className="footer-section" style={styles.section}>
            <h4 style={styles.sectionTitle}>معلومات الاتصال</h4>
            <ul style={styles.linkList}>
              <li style={styles.contactItem}>📍 تونس، تونس</li>
              <li style={styles.contactItem}>
              📞 <a href="tel:+21671232433" style={styles.contactLink} dir="ltr">+216 71 232 433</a>
            </li>
              <li style={styles.contactItem}>
              ✉️ <a href="mailto:contact@ligue-amateur-n2.tn" style={styles.contactLink} dir="ltr">contact@ligue-amateur-n2.tn</a>
            </li>
            </ul>
          </div>

          <div className="footer-section" style={styles.section}>
            <h4 style={styles.sectionTitle}>تابعنا</h4>
            <div style={styles.socialLinks}>
              <a href="#" style={{...styles.socialBtn, background: '#1877f2'}}>
                <FaFacebook />
              </a>
              <a href="#" style={{...styles.socialBtn, background: '#1da1f2'}}>
                <FaTwitter />
              </a>
              <a href="#" style={{...styles.socialBtn, background: '#e4405f'}}>
                <FaInstagram />
              </a>
              <a href="#" style={{...styles.socialBtn, background: '#ff0000'}}>
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>

        <div style={styles.bottom}>
          <p style={styles.copyright}>
            © 2024 الرابطة الوطنية. جميع الحقوق محفوظة.
          </p>
          <p style={styles.createdBy}>
            Site créé par{' '}
            <a href="https://inveep.com" target="_blank" rel="noopener noreferrer" style={styles.createdByLink} className="footer-createdby-inveep-link">INVEEP</a>
            {' | '}
            تم إنشاء الموقع بواسطة{' '}
            <a href="https://inveep.com" target="_blank" rel="noopener noreferrer" style={styles.createdByLink} className="footer-createdby-inveep-link">INVEEP</a>
          </p>
          <p style={styles.devBy} className="footer-dev-inveep">
            {devText}
          </p>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    background: '#1a1a1a',
    color: 'white',
    padding: '40px 16px 20px',
    width: '100%',
    maxWidth: '100vw',
    boxSizing: 'border-box'
  },
  container: {
    width: '100%',
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 16px',
    boxSizing: 'border-box'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(250px, 100%), 1fr))',
    gap: '32px',
    marginBottom: '40px'
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    minWidth: 0
  },
  logoSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '15px'
  },
  footerLogo: {
    height: '100px',
    width: 'auto',
    objectFit: 'contain'
  },
  footerLogoIcon: {
    fontSize: '80px',
    color: '#c41e3a'
  },
  footerTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#c41e3a',
    textAlign: 'center'
  },
  description: {
    fontSize: '14px',
    color: '#ccc',
    lineHeight: 1.6
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#c41e3a'
  },
  linkList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  link: {
    color: '#ccc',
    textDecoration: 'none',
    fontSize: '14px',
    transition: 'color 0.3s'
  },
  contactItem: {
    color: '#ccc',
    fontSize: '14px',
    lineHeight: 1.8
  },
  contactLink: {
    color: '#ccc',
    textDecoration: 'none',
    transition: 'color 0.2s'
  },
  socialLinks: {
    display: 'flex',
    gap: '15px'
  },
  socialBtn: {
    width: '45px',
    height: '45px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: '20px',
    textDecoration: 'none',
    transition: 'transform 0.3s'
  },
  bottom: {
    borderTop: '1px solid rgba(255,255,255,0.1)',
    paddingTop: '20px',
    textAlign: 'center'
  },
  copyright: {
    fontSize: '14px',
    color: '#999',
    marginBottom: '10px'
  },
  createdBy: {
    fontSize: '13px',
    color: '#c41e3a',
    fontWeight: 'bold',
    marginTop: '10px'
  },
  createdByLink: {
    color: '#c41e3a',
    fontWeight: 'bold',
    textDecoration: 'none',
    transition: 'color 0.2s ease, text-decoration 0.2s ease'
  },
  devBy: {
    fontSize: '12px',
    color: '#888',
    marginTop: '8px',
    marginBottom: 0,
    textAlign: 'center'
  },
  devLink: {
    color: '#888',
    textDecoration: 'none',
    transition: 'color 0.2s ease',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px'
  },
  devLinkIcon: {
    fontSize: '10px',
    color: '#888',
    flexShrink: 0
  }
};

export default Footer;
